import { ChangeDetectionStrategy, Component, computed, input, OnChanges, output, signal } from '@angular/core';
import { ISuggestion, ITicketDrawerRequest } from 'src/app/models';
import { ModalQueryParam } from 'src/app/models/enums';
import { ModalUrlService } from 'src/app/services/modal-url/modal-url.service';
import { SuggestionService } from 'src/app/services/suggestion/suggestion.service';
import { suggestionUserTypeOf } from 'src/app/utils/suggestionTickets';

@Component({
  selector: 'app-ticket-drawer',
  templateUrl: './ticket-drawer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TicketDrawerComponent implements OnChanges {
  readonly request = input<ITicketDrawerRequest | undefined>();
  readonly closed = output<void>();
  readonly saved = output<ISuggestion>();

  readonly suggestion = signal<ISuggestion | undefined>(undefined);
  readonly shouldOpenConversation = signal(false);
  readonly userType = computed(
    () => this.request()?.userType ?? suggestionUserTypeOf(this.suggestion()?.type ?? ''),
  );

  constructor(
    private suggestionService: SuggestionService,
    private modalUrlService: ModalUrlService,
  ) {}

  async ngOnChanges() {
    const request = this.request();
    this.shouldOpenConversation.set(false);
    if (!request) {
      this.suggestion.set(undefined);
      return;
    }
    const suggestion = request.suggestionId
      ? ((await this.suggestionService.getSuggestionById(request.suggestionId)) as ISuggestion)
      : request.newSuggestion;
    if (this.request() !== request) return;
    this.suggestion.set(suggestion);
    if (request.suggestionId) this.restoreConversationModal(request);
  }

  close() {
    this.suggestion.set(undefined);
    this.closed.emit();
  }

  private async restoreConversationModal(request: ITicketDrawerRequest) {
    if (!(await this.modalUrlService.consumeOpenState(ModalQueryParam.CONVERSATION))) return;
    if (this.request() === request) this.shouldOpenConversation.set(true);
  }
}
